import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "app-tisco-intro",
    templateUrl: "./tisco-intro.component.html",
    styleUrls: ["./tisco-intro.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TiscoIntroComponent implements OnInit {


  @Input() images: string;
  @Input() imagesMobile: string;
  @Input() title: string;
  @Input() description: string;

  constructor() {}

  ngOnInit() { }
}
